<template>
  <div>
    <div class="product-image-container">
      <img :src="product.image_url">
      <span v-if="product.price_on_sale" class="on-sale-flag">
        SALE!
      </span>
    </div>
    <div class="name">
      {{ product.name }}
    </div>

    <div class="price" :class="{'on-sale': product.price_on_sale}">
      ${{ product.price_dollars }}

      <span v-if="product.price_on_sale" class="price origin-price">
        ${{ product.origin_price_dollars }}
      </span>
    </div>

    <div v-if="product.price_on_sale && product.sale_end_at" class="on-sale-end-container">
      On sale until {{ product.sale_end_at }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    product: { required: true, type: Object },
  },
};
</script>
